
export const REALTIME_MODELS = [
  { value: "gpt-realtime-2.1-mini", label: "gpt-realtime-2.1-mini (económico)" },
  { value: "gpt-realtime-2.1", label: "gpt-realtime-2.1" },
  { value: "gpt-realtime-mini", label: "gpt-realtime-mini (económico)" },
  { value: "gpt-realtime-2", label: "gpt-realtime-2" },
  { value: "gpt-realtime-1.5", label: "gpt-realtime-1.5" },
  { value: "gpt-realtime", label: "gpt-realtime" },
];

export const REALTIME_VOICES = [
  { value: "marin", label: "Marin (femenina)", gender: "F" },
  { value: "cedar", label: "Cedar (masculina)", gender: "M" },
  { value: "alloy", label: "Alloy", gender: "F" },
  { value: "ash", label: "Ash", gender: "M" },
  { value: "ballad", label: "Ballad", gender: "M" },
  { value: "coral", label: "Coral", gender: "F" },
  { value: "echo", label: "Echo", gender: "M" },
  { value: "sage", label: "Sage", gender: "F" },
  { value: "shimmer", label: "Shimmer", gender: "F" },
  { value: "verse", label: "Verse", gender: "M" },
];
